<template>
  <div>
    <!-- Itens do Carrinho -->
    <ul
      v-if="cartItemList.length > 0"
      class="atm-cart-list-container list-unstyled"
    >
      <atm-cart-item
        v-for="item in cartItemList"
        :key="`cart_item-${item.localId || item.id}`"
        :cart-item="item"
      />
    </ul>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
    >
      <p>Nenhum produto adicionado</p>
    </div>

    <!-- Featured Suggestions -->
    <div
      v-if="featuredSuggestions.length > 0"
      class="featured-suggestions-container mt-1"
    >
      <ul class="atm-cart-list-container list-unstyled">
        <atm-cart-item
          v-for="item in transformedFeaturedSuggestions"
          :key="`featured_item-${item.localId || item.id}`"
          :cart-item="item"
          :is-suggestion="true"
          :is-featured="item.isFeatured"
          :busy="busy"
          @add-suggestion="onAddSuggestion"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { payBoxUtils } from '@/mixins'
import AtmCartItem from '../cards/AtmCartItem.vue'

export default {
  components: {
    AtmCartItem,
  },

  props: {
    cartItemList: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('pages/pdv/payBox', ['getFeaturedSuggestions']),
    featuredSuggestions() {
      return this.getFeaturedSuggestions
    },
    transformedFeaturedSuggestions() {
      return this.featuredSuggestions.map(suggestion => this.transformSuggestionToCartItem(suggestion))
    },
  },

  methods: {
    /**
     * Converte dados de sugestão em destaque para estrutura compatível com AtmCartItem
     * @param {object} suggestion - PayBoxSkuResponseDto com dados de sugestão
     * @returns {object} - Estrutura compatível com cartItem
     */
    transformSuggestionToCartItem(suggestion) {
      const { priceRules } = payBoxUtils.buildPriceRulesFromProduct(suggestion)

      const { priceRuleSelected } = payBoxUtils.getPriceRule(
        {
          quantity: 0,
          promotionId: suggestion.promotionId,
          priceTableId: suggestion.priceTable?.id,
          productKitId: null,
        },
        priceRules
      )

      return {
        id: suggestion.skuId,
        localId: suggestion.skuId,
        quantity: 0,
        ean: suggestion.ean,
        skuProduct: {
          id: suggestion.skuId,
          skuId: suggestion.skuId,
          name: suggestion.name,
          imageSquare: suggestion.imageSquare,
          kit: false,
          stock: suggestion.quantityStock || suggestion.stock || 0,
        },
        priceRuleSelected,
        kitItems: [],
        isKit: false,
        isFeatured: suggestion.isFeatured, // Manter informação de destaque para uso na exibição
      }
    },

    async onAddSuggestion(suggestion) {
      try {
        // Emitir evento para o componente pai adicionar o item ao carrinho
        // A ação do Vuex vai buscar o produto completo e aplicar as regras de preço finais
        this.$emit('add-suggestion', {
          skuId: suggestion.skuProduct?.skuId ?? suggestion.skuId,
          ean: suggestion.ean,
          quantity: suggestion.quantity ?? 1,
          priceTableId: suggestion.priceRuleSelected?.priceTable?.id,
          unitValue: suggestion.priceRuleSelected?.priceInfo?.price || suggestion.priceRuleSelected?.priceInfo?.unitValue,
          inputMethod: suggestion.inputMethod,
        })
      } catch (error) {
        console.error('Erro ao adicionar sugestão:', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.atm-cart-list-container {
  & > li + li {
    margin-top: 20px;
  }
}

.featured-suggestions-container {
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;

  .featured-header {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    font-size: 0.9rem;
    color: #666;
  }
}
</style>
